import { render, staticRenderFns } from "./buscardorSintomas.vue?vue&type=template&id=54cf5036&"
import script from "./buscardorSintomas.vue?vue&type=script&lang=js&"
export * from "./buscardorSintomas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports